import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// R14: Session-Ablauf zentral melden. Auth-Endpoints sind ausgenommen --
// deren 401 ist Teil des normalen Login-/Prüf-Flows.
export const AUTH_EXPIRED_EVENT = "pw:auth-expired";

api.interceptors.response.use(
    (resp) => resp,
    (error) => {
        const status = error.response?.status;
        const url = error.config?.url || "";
        if (status === 401 && !url.startsWith("/auth/")) {
            window.dispatchEvent(new Event(AUTH_EXPIRED_EVENT));
        }
        return Promise.reject(error);
    }
);

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Es ist ein Fehler aufgetreten. Bitte erneut versuchen.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
